import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  padding-bottom: 32px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e8eaf0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
`;

export const Lead = styled.p`
  font-size: ${fontSizes.sm}px;
  color: var(--color-text-complement);
  line-height: 1.5;
  margin-bottom: 20px;
`;

export const SubmitBtn = styled.button`
  width: 100%;
  margin-top: 8px;
  height: 5.6rem;
  border: none;
  border-radius: 12px;
  background: ${TAB_BAR.primary};
  color: #fff;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.92;
  }
`;
